<template>
  <modal class="modal" name="buy-track-modal" transition="pop-out" :width="modalWidth" height="auto" :scrollable="true"
         :adaptive="true" :clickToClose="false" @before-close="beforeClose" @before-open="beforeOpen">
    <div class="flex flex-column items-center modal">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times"/>
        </a>
      </div>
      <div class="flex justify-center fl w-30 pb2">
        <img class="h-100 w-100" src="../../../assets/logo-white.svg" alt="BeatHey Logo">
      </div>
      <h1 v-if="track" class="f3 mv2 textColor">{{ $t("tracks.buyTrack.title") + track.name }}</h1>
      <div v-show="loading" class="mv2 textColor">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>
      <div class="flex justify-center ph5-ns w-100">
        <track-info v-if="track" :track="track" :inModal="true" class="flex justify-center"></track-info>
      </div>
      <div class="f7 ph6-ns w-100 miniscreen textColor">
        <p class="tc textColor"> {{ $t("tracks.buyTrack.line1") }}</p>
        <p class="tc textColor"> {{ $t("tracks.buyTrack.line2") }}</p>
        <p class="errorText mh3 tc f7" v-if="error">{{error}}</p>
        <form>
          <div class="flex flex-column justify-center items-center">
            <span class="errorText ma1 f7"
                  v-if="$v.value.$error && !$v.value.required">{{ $t("error.valueRequired") }}</span>
            <div class="flex justify-center" v-if="suggestedValues[currency]">
              <label class="ma2 flex items-center miniscreen" v-for="item in suggestedValues[currency]"
                     :track-by="item"
                     :key="item">
                <input v-model="value" name="value" type="radio" :value="item | currency(2)" checked> ${{ item | currency(2) }}
              </label>
            </div>
            <div class="w-100 flex items-center justify-center flex-wrap mv1">
              <span class="errorText ma1 f7"
                  v-if="$v.value.$error && !$v.value.decimal">{{ $t("error.valueInvalid") }}</span>
              <span class="errorText ma1 f7"
                    v-if="$v.value.$error && !$v.value.greaterThanZero">{{ $t("error.valueInvalid") }}</span>
                    <span class="errorText ma1 f7"
                      v-if="$v.value.$error && !$v.value.minValue">{{ $t("error.valueMinPrice") }} ${{ suggestedValues[currency][0] | currency(2) }}</span>
              <label class="mh2 textColor"> {{ $t("tracks.buyTrack.valueLabel") }}: {{ value }}</label>
              
              <select v-model="currency">
                <option v-for="curr in currencies" :value="curr" :key="curr">{{ curr }}</option>
              </select>
            </div>
            <p class="tc mt0 textColor"> {{ $t("tracks.buyTrack.downloadMessage") }}</p>
            <button class="w-30-ns w-90 block pointer dim b f5 fw4 btn textColor" @click.prevent="modalBuy">{{
              $t("tracks.buyTrack.button") }}
            </button>
          </div>
        </form>
      </div>
      <div class="ph4-ns ph1 pv1 f7 w-100 flex">
        <div class="flex flex-column">
          <p class="b textColor" v-if="actualLicense">{{actualLicense.titulo}}</p>
          <a v-if="actualLicense" :href="actualLicense.link" target="_blank"><img v-show="licenseIcon" :src="licenseIcon" :alt="actualLicense.titulo"></a>
        </div>
        <p v-if="actualLicense" class="pl2 textColor">{{actualLicense.descripcion}}</p>
      </div>
    </div>
  </modal>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import {required, decimal, minValue} from 'vuelidate/lib/validators'
  import {mapGetters, mapActions} from 'vuex'
  import TrackInfo from '@/components/tracks/TrackInfo.vue'

  const MODAL_WIDTH = 600

  const currencies = ['ARS', 'USD']
  
  const minValueHelper = (track) =>
    (value, v) => {
      return value >= v.suggestedValues[v.currency][0]
    }
  export default {
    name: 'buy-track-modal',
    components: {
      FontAwesomeIcon,
      ClipLoader,
      TrackInfo
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '30px',
        value: 10,
        currency: currencies[0],
        currencies: currencies,
        suggestedValues: {
          ARS: [],
          USD: []
        },
        track: null,
        actualLicense: null
      }
    },
    created () {
      this.modalWidth = window.innerWidth < MODAL_WIDTH
        ? MODAL_WIDTH / 2
        : MODAL_WIDTH
      this.getLicenses()
    },
    computed: {
      ...mapGetters('track', [
        'error',
        'prices'
      ]),
      ...mapGetters('user', [
        'user',
        'isLoggedIn'
      ]),
      ...mapGetters('license', [
        'licenses'
      ]),
      licenseIcon () {
        return '/static/' + this.actualLicense.icon
      },
      loading () {
        return (this.$loading.isLoading('track getBuyLink') || this.$loading.isLoading('track getLicenses'))
      }
    },
    methods: {
      ...mapActions('track', [
        'getBuyLink',
        'resetError',
        'getConvertedValues'
      ]),
      ...mapActions('license', [
        'getLicenses'
      ]),
      closeModal () {
        this.value = 1
        this.$modal.hide('buy-track-modal')
      },
      modalBuy () {
        if (!this.$v.$invalid) {
          this.$modal.hide('buy-track-modal')
          this.$modal.show('payment-modal', {
            value: this.value,
            track: this.track,
            currency: this.currency,
            paymentUrl: '',
            suggestedValues: this.suggestedValues
          })
          this.value = 1
        } else {
          this.$v.$touch()
        }
      },
      beforeOpen (event) {
        let providerCountry = localStorage.getItem('providerCountry')
        if (this.user.country) {
          if (this.user.country !== 'ARG' && this.user.country !== 'AR' && this.user.country !== 'Argentina' && this.user.country !== 'argentina') {
            this.currencies = ['USD']
            this.currency = currencies[1]
          }
        }
        if (providerCountry) {
          if (providerCountry !== 'ARG' && this.user.country !== 'AR') {
            this.currencies = ['USD']
            this.currency = currencies[1]
          }
        }
        this.track = null
        this.actualLicense = null
        this.$v.$reset()
        this.track = event.params.track
        this.actualLicense = this.licenses[this.track.id_lisense - 1]
        this.getConvertedValues({
          track: this.track,
          toCurrency: 'ARS'
        }).then((res) => {
          this.suggestedValues[res.currency] = res.values
        })

        this.getConvertedValues({
          track: this.track,
          toCurrency: 'USD'
        }).then((res) => {
          this.suggestedValues[res.currency] = res.values
        })
      },
      beforeClose () {
        this.resetError()
      }
    },
    validations: {
      value: {
        required,
        decimal,
        [minValue]: minValueHelper(this.track),
        greaterThanZero: (value) => {
          return value > 0
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~@/variables.scss';

  .imputBuyTrack {
    background-color: $background-color;
    color: $text-color;
  }

  .modal {
    z-index: 10000;
  }

  .error {
    border: 1px solid rgba(255, 0, 0, 0.7);
  }

  .pop-out-enter-active,
  .pop-out-leave-active {
    transition: all 0.5s;
  }

  .pop-out-enter,
  .pop-out-leave-active {
    opacity: 0;
    transform: translateY(24px);
  }

    @media screen and (max-width: 600px) {
    .miniscreen {
      font-size: 0.6rem;
      margin: 0.25rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/tracks/BuyTrackModal.vue